<template>
  <div>
    <el-form :model="form" :rules="rules" ref="dataForm" class="demo-form-inline">
      <el-form-item prop="paraTextForWeb">
        <div id="J_quillEditor"></div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import 'quill/dist/quill.snow.css'
import Quill from 'quill'
export default {
  name: 'imgInfo', // 商品图文
  data () {
    return {
      form: {
        paraTextForWeb: ''
      },
      rules: {
        // paraTextForWeb: [{
        //   required: true,
        //   message: this.$t('validate.required'),
        //   trigger: 'blur'
        // }]
      },
      quillEditor: null,
      quillEditorToolbarOptions: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block', 'image'],
        [{ header: 1 }, { header: 2 }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ direction: 'rtl' }],
        [{ size: ['small', false, 'large', 'huge'] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ color: [] }, { background: [] }],
        [{ font: [] }],
        [{ align: [] }],
        ['clean']
      ]
    }
  },
  methods: {
    // 富文本编辑器
    quillEditorHandle () {
      this.quillEditor = new Quill('#J_quillEditor', {
        modules: {
          toolbar: this.quillEditorToolbarOptions
        },
        theme: 'snow'
      })
      // 监听内容变化，动态赋值
      this.quillEditor.on('text-change', () => {
        this.form.paraTextForWeb = this.quillEditor.root.innerHTML
      })
    },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            resolve()
          } else {
            reject(new Error('图文描述填写不正确！'))
          }
        })
      })
    },
    getDataForm () {
      return this.form.paraTextForWeb
    },
    setDataForm (data) {
      this.$nextTick(() => {
        this.quillEditor.root.innerHTML = data.remark
      })
      this.form.paraTextForWeb = data.remark
    },
    resetDataForm () {
      this.$refs['dataForm'].resetFields()
      this.$nextTick(() => {
        this.quillEditor.root.innerHTML = ''
      })
      this.form.paraTextForWeb = ''
    }
  },
  mounted () {
    // 生成富文本
    this.$nextTick(() => {
      this.quillEditorHandle()
    })
  }
}
</script>

<style>

</style>
